exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-input[data-v-7c8ecb33] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: space-between;\n}\n.name-input__name[data-v-7c8ecb33] {\n  flex-grow: 1;\n  margin-right: 10px;\n  align-self: stretch;\n}\n.name-input__choose[data-v-7c8ecb33] {\n  margin: auto;\n  margin-right: 10px !important;\n}", ""]);

// exports
